export const PMT60001 = "PMT60001";   // CREDIT CARD CODE
export const PMT60004 = "PMT60004";   // BYPASS CODE
export const BY_PASS  = "by_pass";    // BYPASS STRING
